<template>
  <div class="card p-shadow-app">
    <h1>Marcas</h1>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog></ConfirmDialog>
    <div style="height: 65vh">
      <DataTable
        :value="list"
        :filters.sync="filters"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        sortMode="single"
        responsiveLayout="scroll"
        :scrollable="true"
        scrollHeight="flex"
      >
        <template #empty> Nada a mostrar. </template>
        <template #loading> A carregar. Por favor Aguarde... </template>
        <template #header>
          <div class="table-header">
            <Button
              icon="pi pi-plus"
              @click="addNew"
              v-if="can('createUpdateParts')"
              class="p-mr-2"
            />
            <Button
              icon="pi pi-sync"
              label="Sincronizar de PrestaShop"
              @click="importBrands"
              v-if="can('createUpdateParts')"
              class="p-button-secondary"
              v-tooltip="'Importar/Atualizar marcas vindas do PrestaShop'"
            />
          </div>
        </template>
        <Column field="name" filterField="name" header="Nome" sortable>
          <template #body="slotProps">
            <span
              class="clickable-item"
              v-tooltip="'Alterar Nome'"
              @click="edit(slotProps.data)"
              v-if="can('createUpdateParts')"
            >
              {{ slotProps.data.name ?? "_______" }}
            </span>
            <span v-else>{{ slotProps.data.name ?? "" }}</span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column field="active" header="Activa" sortable filterField="active">
          <template #body="slotProps">
            {{ slotProps.data.active == 1 ? "Sim" : "Não" }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="[
                { value: 0, label: 'Não' },
                { value: 1, label: 'Sim' },
              ]"
              optionValue="value"
              optionLabel="label"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
        <Column header="Ações" v-if="can('createUpdateParts')" :style="{ width: '100px' }">
          <template #body="slotProps">
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger p-button-text"
              @click="confirmDelete(slotProps.data)"
              v-tooltip="'Eliminar Marca'"
            />
          </template>
        </Column>
      </DataTable>
    </div>
    <Dialog
      :visible.sync="form.show"
      :containerStyle="{ width: $isMobile() ? '100vw' : '40vw' }"
      :maximizable="true"
      :modal="true"
      v-on:hide="hideForm"
      v-on:show="
        () => {
          $validator.resume();
        }
      "
      :header="form.id ? 'Editar Marca' : 'Nova Marca'"
    >
      <form class="p-col-12" @submit.prevent="save">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-10">
            <span class="p-float-label">
              <InputText
                :id="'name'"
                :name="'name'"
                autocomplete="off"
                v-validate="'required'"
                v-model="form.name"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('name'),
                  },
                  'form-control',
                ]"
              />
              <label for="name">Nome</label>
            </span>
            <small v-if="errors.has('name')" class="p-error" role="alert">
              Nome é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-2 p-mt-2">
            <span
              class="p-float-label"
              style="top: -0.75rem; left: -1rem; font-size: 12px"
            >
              <label for="active">Ativa</label>
            </span>
            <InputSwitch
              v-model="form.active"
              :name="'active'"
              :id="'active'"
              style="top: 4px;"
            />
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-sm p-button-success"
          @click="save()"
        />
        <Button
          :label="'Cancelar'"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="hideForm()"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import "vue-loading-overlay/dist/vue-loading.css";
import sparsService from "../../services/spars.service";
import { FilterMatchMode } from "primevue/api";
export default {
  name: "SparsBrands",
  components: {},
  data() {
    return {
      loading: false,
      list: [],
      form: {
        show: false,
        id: null,
        name: null,
        active: null,
      },
      filters: {
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        active: { value: null, matchMode: FilterMatchMode.EQUALS },
      },
    };
  },
  async created() {
    this.loading = true;
    this.list = await sparsService.getBrands() || [];
    this.loading = false;
  },
  deactivated() {
    this.hideForm();
    document.body.classList.remove('p-overflow-hidden');
  },
  beforeDestroy() {
    document.body.classList.remove('p-overflow-hidden');
  },
  methods: {
    hideForm() {
      this.$validator.pause();
      this.$validator.reset();
      return (this.form = {
        show: false,
        id: null,
        name: null,
        active: true,
      });
    },
    addNew() {
      return (this.form = {
        show: true,
        id: null,
        name: null,
        active: true,
      });
    },
    edit(data) {
      return (this.form = {
        show: true,
        id: data.id,
        name: data.name,
        active: data.active == 1 ? true : false,
        data: data,
      });
    },
    save() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }
        this.loading = true;
        if (this.form.id) {
          return this.saveEdit();
        }
        return this.saveNew();
      });
    },
    getFormParams() {
      return {
        name: this.form.name,
        active: this.form.active ? 1 : 0,
      };
    },
    saveNew() {
      this.loading = true;

      return sparsService.newBrand(this.getFormParams()).then((response) => {
        this.loading = false;
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Erro ao adicionar marca",
            life: 3000,
          });
        }
        this.list.push(response);
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Marca adicionada com sucesso",
          life: 3000,
        });
        return this.hideForm();
      });
    },
    saveEdit() {
      this.loading = true;
      return sparsService
        .updateBrand(this.form.id, this.getFormParams())
        .then((response) => {
          this.loading = false;
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Erro ao atualizar marca",
              life: 3000,
            });
          }
          const index = this.list.findIndex((item) => item.id === this.form.id);
          if (index !== -1) {
            this.$set(this.list, index, response);
          }
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Marca atualizada com sucesso",
            life: 3000,
          });
          return this.hideForm();
        });
    },
    async importBrands() {
      this.$confirm.require({
        message: 'Tem a certeza que deseja importar todas as marcas do PrestaShop? Este processo pode atualizar nomes e estados de marcas locais.',
        header: 'Importar Marcas',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: async () => {
          this.loading = true;
          const response = await sparsService.importBrands();
          this.loading = false;
          if (!response) {
            this.$toast.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao importar marcas',
              life: 3000,
            });
            return;
          }
          this.list = response;
          this.$toast.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Marcas importadas com sucesso',
            life: 3000,
          });
        }
      });
    },
    confirmDelete(data) {
      this.$confirm.require({
        message: `Tem a certeza que deseja eliminar a marca "${data.name}"?`,
        header: 'Confirmar Eliminação',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: () => {
          this.executeDelete(data.id, false);
        }
      });
    },
    executeDelete(id, force = false) {
      this.loading = true;
      sparsService.deleteBrand(id, force).then((response) => {
        this.loading = false;
        if (!response) {
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Erro ao eliminar marca",
            life: 3000,
          });
          return;
        }

        if (response.requires_confirmation) {
          this.$confirm.require({
            message: `Esta marca possui ${response.products_count} produto(s) associado(s). Se continuar, a marca será eliminada e os produtos associados serão desassociados. Deseja forçar a eliminação?`,
            header: 'Aviso de Relações Existentes',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim, forçar',
            rejectLabel: 'Não',
            accept: () => {
              this.executeDelete(id, true);
            }
          });
          return;
        }

        this.list = response;
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Marca eliminada com sucesso",
          life: 3000,
        });
      });
    },
  },
};
</script>
